var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6498 3.53377C10.0014 2.87051 10.9517 2.87052 11.3033 3.53377L12.2328 5.28695C13.0075 6.74817 14.2028 7.94339 15.664 8.7181L17.4172 9.6476C18.0804 9.99924 18.0804 10.9495 17.4172 11.3011L15.664 12.2306C14.2028 13.0053 13.0075 14.2006 12.2328 15.6618L11.3033 17.415C10.9517 18.0782 10.0014 18.0782 9.64979 17.415L8.72029 15.6618C7.94559 14.2006 6.75036 13.0053 5.28915 12.2306L3.53597 11.3011C2.87271 10.9495 2.87271 9.99924 3.53597 9.6476L5.28915 8.7181C6.75036 7.94339 7.94559 6.74817 8.72029 5.28695L9.6498 3.53377Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2808 14.6667C17.4311 14.3832 17.8374 14.3832 17.9878 14.6667L18.3852 15.4163C18.7164 16.0411 19.2275 16.5521 19.8522 16.8834L20.6018 17.2808C20.8854 17.4311 20.8854 17.8374 20.6018 17.9878L19.8522 18.3852C19.2275 18.7164 18.7164 19.2275 18.3852 19.8522L17.9878 20.6018C17.8374 20.8854 17.4311 20.8854 17.2808 20.6018L16.8834 19.8522C16.5521 19.2275 16.0411 18.7164 15.4163 18.3852L14.6667 17.9878C14.3832 17.8374 14.3832 17.4311 14.6667 17.2808L15.4163 16.8834C16.0411 16.5521 16.5521 16.0411 16.8834 15.4163L17.2808 14.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/Sparkle.f91339a5685abe8874b19da92fb91322.svg";
export { ForwardRef as ReactComponent };